/*       */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Link from 'app/components/atoms/Link/Link';

const ProcessLink = props => {
    const { id, children, path, noDecoration, ...restProps } = props;
    const tab = path ? `/${path}` : '';
    return (
        <Link to={`/abox/process/${id}${tab}`} noDecoration={noDecoration} {...restProps}>
            {children}
        </Link>
    );
};

ProcessLink.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    noDecoration: PropTypes.bool,
    children: PropTypes.node,
};

export default memo(ProcessLink);
